(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4685],{

/***/ 90153:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/donate",
      function () {
        return __webpack_require__(19823);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 19823:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62044);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56168);
/* harmony import */ var _components_Layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46323);
/* harmony import */ var _components_Select_Select__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(53173);
/* harmony import */ var _enums_namespaces__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99731);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(17651);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(56047);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(75332);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var context__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(52662);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(50744);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(1984);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var context_langContext__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(70082);













var DonateList = function(param) {
    var theatres = param.theatres, countryCode = param.countryCode;
    var ref, ref1, ref2;
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_enums_namespaces__WEBPACK_IMPORTED_MODULE_5__/* .Namespace.Theaters */ .l.Theaters).t;
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(theatres[0].id), selected = ref3[0], setSelected = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)();
    var locale = (0,context_langContext__WEBPACK_IMPORTED_MODULE_11__/* .useLang */ .J)().locale;
    var RULE_NOT_EMPTY = t("common:form.not_empty");
    var onSubmit = function(event) {
        event.preventDefault();
        event.stopPropagation();
        var formSchema = (0,_helpers__WEBPACK_IMPORTED_MODULE_6__/* .createFormSchema */ .ZS)({
            theatre: (0,_helpers__WEBPACK_IMPORTED_MODULE_6__/* .notEmptyRule */ .ji)(RULE_NOT_EMPTY)
        });
        var validateObject = {
            theatre: selected
        };
        var isValid = (0,_helpers__WEBPACK_IMPORTED_MODULE_6__/* .validateForm */ .G$)(formSchema, validateObject, ref4.current);
        if (isValid) {
            router.push(_helpers__WEBPACK_IMPORTED_MODULE_6__/* .Permalink.donateTheatre */ .xm.donateTheatre(theatres.find(function(t) {
                return t.id === selected;
            }), locale));
        }
        (0,_helpers__WEBPACK_IMPORTED_MODULE_6__/* .resetForm */ .Fx)(ref4.current);
    };
    var getTheater = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        return theatres === null || theatres === void 0 ? void 0 : theatres.find(function(tt) {
            return tt.id === selected;
        });
    }, [
        selected,
        theatres
    ]);
    var getSrcTheatre = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        if (selected) {
            var theatre = getTheater();
            var theatreImg = theatre === null || theatre === void 0 ? void 0 : theatre.poster_url;
            return theatreImg !== null && theatreImg !== void 0 ? theatreImg : "empty";
        }
        return "";
    }, [
        selected,
        theatres
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Layout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        countryCode: countryCode,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_10___default()), {
                children: (0,_helpers__WEBPACK_IMPORTED_MODULE_6__/* .basicSEO */ .Fi)(t("seo:donate_home_title"), t("seo:donate_description"))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("main", {
                className: [
                    (_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().donate),
                    (_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().donateSelect)
                ].join(" "),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().donateWrapper),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: classnames__WEBPACK_IMPORTED_MODULE_9___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().imagePlaceholder), getSrcTheatre() === "empty" ? (_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().withoutLogo) : ""),
                            children: getSrcTheatre() === "empty" ? (ref = getTheater()) === null || ref === void 0 ? void 0 : (ref1 = ref.name) === null || ref1 === void 0 ? void 0 : ref1.substr(0, 1) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: getSrcTheatre(),
                                alt: (ref2 = getTheater()) === null || ref2 === void 0 ? void 0 : ref2.name
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            children: t("choose_donate")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
                            ref: ref4,
                            method: "POST",
                            id: "select-theater-form",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                    children: [
                                        t("theatre"),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Select_Select__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                            defaultLabel: t("choose_theatre"),
                                            name: "theatre",
                                            onChange: function(val) {
                                                return setSelected(+val);
                                            },
                                            options: theatres === null || theatres === void 0 ? void 0 : theatres.map(function(tt) {
                                                return {
                                                    label: tt.name,
                                                    value: tt.id.toString()
                                                };
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {})
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    onClick: onSubmit,
                                    className: "btn btn-primary",
                                    children: t("continue")
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = ((0,context__WEBPACK_IMPORTED_MODULE_8__/* .withForcePlanToLoggedInUnsubs */ .DE)(DonateList));


/***/ }),

/***/ 56047:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"donate":"donate_donate__Vv01Y","donateWrapper":"donate_donateWrapper__3EoWv","radios":"donate_radios__38iLL","donateSelect":"donate_donateSelect__ZAg1g","imagePlaceholder":"donate_imagePlaceholder__iu6hc","withoutLogo":"donate_withoutLogo__cgmAM"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(90153); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);